import { FC, ReactNode } from 'react';
import ExpandIcon from 'assets/icons/arrow-down-grey.svg?react';

import styles from './Accordion.module.scss';
import clsx from 'clsx';
import { useScopedTranslation } from '../../application/localization/useScopedTranslation.ts';

export type AccordionProps = {
  title: string | ReactNode;
  testId?: string;
  replacementText?: string;
  titleClassName?: string;
  replacementTextClassName?: string;
  children?: ReactNode[];
  expanded?: boolean;
  loading?: boolean;
  onExpandClick: () => void;
};

export const Accordion: FC<AccordionProps> = (props) => {
  const i18n = useScopedTranslation('Component.Accordion');
  const expanded = !!props.expanded;

  const hasChildren =
    !!props.children &&
    props.children.length > 0 &&
    props.children.some((child) => !!child);

  return (
    <div data-test-id={props.testId}>
      <p
        className={clsx(props.titleClassName, styles.title)}
        data-expanded={expanded}
        onClick={props.onExpandClick}
      >
        {props.title}
        <ExpandIcon
          className={expanded ? styles.arrowExpanded : styles.arrowCollapsed}
        />
      </p>
      {expanded && hasChildren && props.children}
      {expanded && !hasChildren && (
        <p
          className={clsx(
            styles.replacementText,
            props.replacementTextClassName,
          )}
        >
          {props.loading ? i18n.t('loading') : props.replacementText}
        </p>
      )}
    </div>
  );
};
